/* Storefront activity, gated by Shopify's analytics permission. */
(() => {
  'use strict';
  if (window.Shopify?.designMode || new URL(location.href).searchParams.has('preview_theme_id') || /bot|spider|crawler|HeadlessChrome/i.test(navigator.userAgent)) return;
  const endpoint = 'https://customizer.oazar-shop.com/order-webhook/analytics-collect.php';
  const sessionKey = 'oazar_stats_session_v1';
  const visitorKey = 'oazar_stats_visitor_v1';
  const customer = String(document.querySelector('[data-oazar-analytics-context]')?.dataset.customer || '');
  const customerName = customer ? String(document.querySelector('[data-oazar-analytics-context]')?.dataset.customerName || '').trim() : '';
  const idleMs = 30 * 60 * 1000;
  let session = null, visitor = null, started = false, pageSent = false, pending = [], timer = 0;
  let activeFrom = performance.now(), lastActivity = Date.now();
  const uuid = () => crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(16)), b => b.toString(16).padStart(2, '0')).join('');
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const path = value => {
    try {
      const p = new URL(value, location.origin).pathname;
      if (/^\/(account|checkouts?|orders|password|apps)(\/|$)/i.test(p)) return '';
      return p.slice(0, 180);
    } catch { return '/'; }
  };
  const pagePath = path(location.href);
  if (!pagePath) return;
  const read = (store, key) => { try { return JSON.parse(window[store].getItem(key)); } catch { return null; } };
  const write = (store, key, value) => { try { window[store].setItem(key, JSON.stringify(value)); } catch {} };
  function identities() {
    const now = Date.now();
    if (!visitor) {
      const old = read('localStorage', visitorKey);
      visitor = old && old.expires > now && /^[a-f0-9-]{24,64}$/.test(old.id) ? old : {id: uuid(), expires: now + 90 * 86400000};
      write('localStorage', visitorKey, visitor);
    }
    if (!session) session = read('sessionStorage', sessionKey);
    if (!session || now - session.last > idleMs || (session.customer || '') !== customer || !/^[a-f0-9-]{24,64}$/.test(session.id)) {
      if (pending.length) flush();
      session = {id: uuid(), last: now, customer, ...attribution()};
      pageSent = false;
    }
    session.last = now;
    write('sessionStorage', sessionKey, session);
  }
  function attribution() {
    const url = new URL(location.href);
    const text = value => /@|\+?\d[\d .()]{8,}\d/.test(String(value || '')) ? '' : String(value || '').replace(/[^\p{L}\p{N} ._:/-]/gu, '').slice(0, 80);
    const source = text(url.searchParams.get('utm_source'));
    let referrer = '';
    try { const host = new URL(document.referrer).hostname; if (!['www.oazar-shop.com','oazar-shop.com','oazar-4166.myshopify.com','customizer.oazar-shop.com'].includes(host)) referrer = host; } catch {}
    return {source: source || referrer || 'Accès direct', medium: text(url.searchParams.get('utm_medium')), campaign: text(url.searchParams.get('utm_campaign'))};
  }
  function flush(beacon = false) {
    clearTimeout(timer); timer = 0;
    if (!allowed() || !pending.length || !session || !visitor) { if (!allowed()) pending = []; return; }
    const events = pending.splice(0, 12);
    const region = String(window.Shopify.customerPrivacy.getRegion?.() || '').slice(0, 2).toUpperCase();
    const data = JSON.stringify({consent: true, session: session.id, visitor: visitor.id, customer: session.customer, customer_name: customerName, source: session.source, medium: session.medium, campaign: session.campaign, country: region, device: innerWidth < 750 ? 'mobile' : innerWidth < 1121 ? 'tablet' : 'desktop', events});
    if (beacon && navigator.sendBeacon?.(endpoint, new Blob([data], {type: 'text/plain'}))) return;
    fetch(endpoint, {method: 'POST', headers: {'Content-Type': 'text/plain'}, body: data, credentials: 'omit', keepalive: true}).catch(() => {});
  }
  function queue(type, details = {}) {
    if (!allowed()) return;
    identities();
    if (!pageSent) { pending.push({id: uuid(), type: 'view', at: Math.floor(Date.now()/1000), path: pagePath}); pageSent = true; }
    if (type !== 'view') pending.push({id: uuid(), type, at: Math.floor(Date.now()/1000), path: pagePath, ...details});
    if (pending.length >= 10) flush();
    else if (!timer) timer = window.setTimeout(flush, 1200);
  }
  function engagement() {
    const now = performance.now();
    const delta = Math.max(0, Math.min(30000, Math.round(now - activeFrom)));
    activeFrom = now;
    if (document.visibilityState === 'visible' && Date.now() - lastActivity < 10 * 60000 && delta >= 1000) queue('engagement', {active_ms: delta});
  }
  function start() {
    if (!allowed()) {
      pending = []; session = null; visitor = null; pageSent = false;
      try { localStorage.removeItem(visitorKey); sessionStorage.removeItem(sessionKey); } catch {}
      return;
    }
    queue('view'); activeFrom = performance.now(); lastActivity = Date.now();
    if (started) return;
    started = true;
    document.addEventListener('click', event => {
      lastActivity = Date.now();
      const node = event.target.closest?.('a,button,summary,[role="button"]');
      if (!node || node.closest('[data-oz-cookie-dialog],.shopify-pc__banner__dialog') || node.matches(':disabled,[aria-disabled="true"]')) return;
      const target = path(node.getAttribute('href') || location.href);
      let label = node.getAttribute('aria-label') || node.textContent || 'Bouton';
      if (node.closest('[data-op-search-live],.predictive-search')) label = 'Résultat de recherche';
      label = label.replace(/\s+/g, ' ').trim().slice(0, 80);
      if (/@|\+?\d[\d .()]{8,}\d/.test(label)) label = 'Lien';
      const section = node.closest('.shopify-section');
      // Only public section headings or stable type names; no form values or cart identifiers.
      const heading = section?.querySelector('h2,h1')?.textContent?.replace(/\s+/g, ' ').trim().slice(0, 60) || (node.closest('header,[id^="OazarPebbleV4"]') ? 'Navigation' : 'Page');
      queue('click', {label, target, section: heading});
    }, {capture: true, passive: true});
    ['pointerdown','keydown','scroll'].forEach(name => document.addEventListener(name, () => { lastActivity = Date.now(); }, {passive: true}));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        const delta = Math.round(performance.now() - activeFrom); activeFrom = performance.now();
        if (allowed() && delta >= 1000 && Date.now() - lastActivity < 10 * 60000) queue('engagement', {active_ms: Math.min(30000, delta)});
        flush(true);
      } else { activeFrom = performance.now(); lastActivity = Date.now(); }
    });
    window.addEventListener('pagehide', () => flush(true));
    window.setInterval(engagement, 15000);
  }
  document.addEventListener('visitorConsentCollected', start);
  if (window.Shopify?.customerPrivacy) start();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) start(); });
})();
